import { SvgIconProps } from "@mui/material";

// A large row of 2 panes (2/3 height) above a small row of 2 panes (1/3
// height).
export const SplitGridThirdIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <rect x="2" y="2" width="9" height="12" rx="1.2" />
    <rect x="13" y="2" width="9" height="12" rx="1.2" />
    <rect x="2" y="16" width="9" height="6" rx="1.2" />
    <rect x="13" y="16" width="9" height="6" rx="1.2" />
  </svg>
);
